<template>
	<tr class="requirement-record">
		<td class="pa-1 normal-wrap text-center">
			<v-btn @click="editOrderComponent">編集</v-btn>
		</td>
		<td class="pa-1 normal-wrap text-center">{{ orderComponent.component.part_number }}</td>
		<td class="pa-1 normal-wrap text-center">{{ orderComponent.component.name }}</td>
		<td class="pa-1 normal-wrap text-center">{{ orderComponent.quantity }}</td>
		<td class="pa-1 normal-wrap text-center">
			{{ orderComponent.unit_price ? orderComponent.unit_price.toLocaleString() : "" }}
		</td>
		<td class="pa-1 normal-wrap text-center">{{ orderComponent.remarks }}</td>
		<td class="pa-1 normal-wrap text-center">
			<div
				class="ma-1"
				v-for="file in orderComponent.return_all_attached_file_infos"
				:key="file.id"
			>
				<v-btn v-if="!file.destroy_flag" :href="file.url">{{ file.name }}</v-btn>
			</div>
		</td>
		<EditDialog
			ref="edit"
			@updateOrderComponent="updateOrderComponent"
			@reloadFiles="reloadFiles"
			@reloadIndex="reloadIndex"
		/>
	</tr>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common.js"
import EditDialog from "./EditDialog.vue"
export default {
	components: {
		EditDialog,
	},
	props: {
		orderComponent: {
			component: { name: "", part_number: "" },
			quantity: "",
			return_all_attached_file_infos: [],
		},
	},
	data() {
		return {
			common: common,
			flags: {},
			type: "",
			referenceId: "",
		}
	},
	filters: {
		dateForRecord: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		console.log(this.orderComponent)
	},
	watch: {},
	methods: {
		reloadFiles(files) {
			this.orderComponent.return_all_attached_file_infos = files
			this.$emit("reloadIndex")
		},
		reloadIndex() {
			this.$emit("reloadIndex")
		},
		editOrderComponent() {
			this.$refs.edit.openDialog(this.orderComponent)
		},
		updateOrderComponent(orderComponent) {
			this.$emit("reloadIndex")
		},
		deleteOrderComponent() {},
	},
	computed: {},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
	border-bottom: solid 1px gray;
}
td {
	white-space: pre-wrap;
}

.requirement-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.requirement-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
